module.exports = __webpack_public_path__ + "static/media/ramp-loading.0ce14c3a.svg";